var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          staticClass: "tabs-container",
          staticStyle: { position: "relative" }
        },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "Thailand", name: "thailand", lazy: true } },
                [
                  _c("thailand-info", {
                    attrs: {
                      action: _vm.action,
                      thailand2: _vm.thailand2,
                      form: _vm.thailandForm,
                      container: _vm.thailandContainer,
                      job: _vm.job,
                      "txt-carrier-sc-ac": _vm.txtCarrierScAc,
                      "cooperate-edit": _vm.cooperateEdit
                    },
                    on: {
                      syncThailandInfo: _vm.syncThailandInfo,
                      synchroThailandClickHandler:
                        _vm.btnSynchroThailandClickHandler,
                      removeCargoDoc: _vm.onRemoveThailandCargoDoc
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cooperateEdit,
                  expression: "cooperateEdit"
                }
              ],
              staticStyle: { position: "absolute", left: "320px" }
            },
            [
              _vm.activeTabName === "thailand"
                ? [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "108px" },
                        attrs: { disabled: _vm.thailandEdit, type: "primary" },
                        on: { click: _vm.sendInThailand }
                      },
                      [_vm._v("Send")]
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.thailandExportDialog.visible,
            title: _vm.thailandExportDialog.showReminder
              ? "Reminder"
              : "Preview Message",
            width: "600px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.thailandExportDialog, "visible", $event)
            }
          }
        },
        [
          _vm.thailandExportDialog.showReminder
            ? _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("i", {
                      staticClass: "el-icon-warning",
                      staticStyle: { color: "#E6A23C", "font-size": "20px" }
                    })
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { "flex-grow": "1" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "5px",
                          "line-height": "20px"
                        }
                      },
                      [_vm._v("These fields may have issues")]
                    ),
                    _c("cargo-rich-textarea", {
                      staticStyle: { height: "480px" },
                      attrs: { "text-chars": 0, "warning-count": -1 },
                      model: {
                        value: _vm.thailandExportDialog.reminderContent,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.thailandExportDialog,
                            "reminderContent",
                            $$v
                          )
                        },
                        expression: "thailandExportDialog.reminderContent"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          !_vm.thailandExportDialog.showReminder
            ? _c("cargo-rich-textarea", {
                staticStyle: { height: "500px" },
                attrs: { "text-chars": 0, "warning-count": -1 },
                model: {
                  value: _vm.thailandExportDialog.content,
                  callback: function($$v) {
                    _vm.$set(_vm.thailandExportDialog, "content", $$v)
                  },
                  expression: "thailandExportDialog.content"
                }
              })
            : _vm._e(),
          _vm.thailandExportDialog.showReminder
            ? _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.thailandExportDialog.showReminder = false
                        }
                      }
                    },
                    [_vm._v("Continue")]
                  )
                ],
                1
              )
            : _vm._e(),
          !_vm.thailandExportDialog.showReminder
            ? _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.doExportThailand }
                    },
                    [_vm._v("Export Current Page")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.thailandExportDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s("Close"))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }